module.exports = __webpack_public_path__ + "static/media/user_3.c339af64.svg";